<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="960" @keydown.esc="close">
    <v-card>
      <v-card-title class="py-2 px-4 d-flex align-center justify-space-between">
        <span class="text-subtitle-1 font-weight-medium text-truncate" style="max-width:60%">
          {{ title || fileName }}
        </span>
        <div class="d-flex align-center">
          <template v-if="isImage">
            <v-btn icon small @click="rotate(-90)" title="Rotate left">
              <v-icon>mdi-rotate-left</v-icon>
            </v-btn>
            <v-btn icon small @click="rotate(90)" title="Rotate right">
              <v-icon>mdi-rotate-right</v-icon>
            </v-btn>
          </template>
          <v-btn icon small :href="url" target="_blank" title="Open in new tab">
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn icon small @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-0" style="background:#1a1a1a;">
        <div v-if="!url" class="d-flex justify-center align-center" style="height:420px">
          <div class="text-center grey--text">
            <v-icon size="64" color="grey lighten-2">mdi-file-alert</v-icon>
            <p class="mt-2">No file to display</p>
          </div>
        </div>

        <!-- Image viewer with rotation -->
        <div
          v-else-if="isImage"
          class="img-rotate-wrap"
          :style="{ height: isSideways ? rotatedSize : '72vh' }"
        >
          <img
            :src="url"
            class="img-rotate-img"
            :style="{
              transform: `rotate(${rotation}deg)`,
              maxWidth: isSideways ? rotatedSize : '100%',
              maxHeight: isSideways ? '100%' : '72vh',
              transition: 'transform 0.35s ease',
            }"
            alt="Preview"
          />
        </div>

        <iframe
          v-else
          :src="url"
          width="100%"
          height="640px"
          frameborder="0"
          style="display:block;"
        ></iframe>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];

export default {
  name: 'FileViewer',
  props: {
    value: { type: Boolean, default: false },
    url: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  data() {
    return { rotation: 0 };
  },
  computed: {
    ext() {
      if (!this.url) return '';
      return this.url.split('?')[0].split('.').pop().toLowerCase();
    },
    isImage() {
      return IMAGE_EXTS.includes(this.ext);
    },
    fileName() {
      if (!this.url) return 'File Viewer';
      return decodeURIComponent(this.url.split('?')[0].split('/').pop());
    },
    isSideways() {
      return this.rotation % 180 !== 0;
    },
    rotatedSize() {
      // When rotated 90/270°, the image's visual width = its DOM height.
      // Constrain both to 65vh so neither visual dimension exceeds the container.
      return '65vh';
    },
  },
  watch: {
    value(open) {
      if (open) this.rotation = 0;
    },
  },
  methods: {
    rotate(deg) {
      this.rotation = (this.rotation + deg + 360) % 360;
    },
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped>
.img-rotate-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
}

.img-rotate-img {
  display: block;
  object-fit: contain;
}
</style>
